import constructionApi from "../../../api/account/construction";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // 获取列表
  getLst({ state }, { params, callback }) {
    console.log(state);
    constructionApi.getLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取详情
  getDtl({ state }, { params, callback }) {
    console.log(state);
    constructionApi.getDtlApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/construction.js